module.exports = __webpack_public_path__ + "img/view-plans.8bf01a6d.png";